import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hvzcufrhbviodzhbvzmz.supabase.co';
const supabaseAnonKey = 'sb_publishable_8LX-YP6FeMnd4VhYLHMIRw_YBXJFB_a';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);